module.exports = __webpack_public_path__ + "img/evaluate_gray_6.af6130c2.png";